import { createSelector } from "reselect";
import { tAboutData, tLink, tStats, tLeaders, tText, tLeadersList, tTeam } from "../types";

const getState = (state) => state.aboutReducer.about;

const aboutSelector = createSelector([getState], (item) => {

    let results: tAboutData;

    if (item) {

        //let headerStats: tHeaderStats;
        //let content: tContent[] = [];
        let link: tLink;
        let stats: tStats[] = [];
        let leaders: tLeaders;
        let text: tText[] = [];
        let team: tTeam;

        const { attributes } = item;

        if (attributes && attributes.Stats && attributes.Stats.length > 0) {
            attributes.Stats.forEach(stat => {
                stats = [
                    ...stats,
                    {
                        id: stat.id,
                        caption: stat.Caption,
                        icon: stat.Icon && stat.Icon.data && stat.Icon.data.attributes && stat.Icon.data.attributes.url && stat.Icon.data.attributes.url,
                    }
                ];
            });
        }

        if (attributes && attributes.Text && attributes.Text.length > 0) {
            attributes.Text.forEach(textItem => {
                text = [
                    ...text,
                    {
                        id: textItem.id,
                        title: textItem.Title,
                        description: textItem.Description,
                    }
                ];
            });
        }

        if (attributes && attributes.Leaders) {

            let leadersList: tLeadersList[] = [];
            if (attributes.Leaders.Leaders && attributes.Leaders.Leaders.length > 0) {
                attributes.Leaders.Leaders.forEach(leader => {
                    leadersList = [
                        ...leadersList,
                        {
                            id: leader.id,
                            name: leader.Name,
                            position: leader.Position,
                            description: leader.Description,
                            photo: leader.Photo && leader.Photo.data && leader.Photo.data.attributes && leader.Photo.data.attributes.url && leader.Photo.data.attributes.url,
                        }
                    ];
                });
            }

            leaders = {
                id: attributes.Leaders.id,
                title: attributes.Leaders.Title,
                image: attributes.Leaders && attributes.Leaders.Image && attributes.Leaders.Image.data && attributes.Leaders.Image.data.attributes && attributes.Leaders.Image.data.attributes.url && attributes.Leaders.Image.data.attributes.url,
                leaders: leadersList,
                link: {
                    title: attributes.Leaders.Link && attributes.Leaders.Link.Title,
                    url: attributes.Leaders.Link && attributes.Leaders.Link.Url,
                },
            }

        }

        if (attributes && attributes.Team) {
            let teamText: tText[] = [];
            if (attributes.Team.Text && attributes.Team.Text.length > 0) {
                attributes.Team.Text.forEach(teamItem => {
                    teamText = [
                        ...teamText,
                        {
                            id: teamItem.id,
                            title: teamItem.Title,
                            description: teamItem.Description,
                        }
                    ];
                });
            }
            team = {
                id: attributes.Team.id,
                title: attributes.Team.Title,
                text: teamText,
            }
        }

        results = {
            id: item.id,
            title: attributes && attributes.Title,
            caption: attributes && attributes.Caption,
            image: attributes && attributes.Image &&  attributes.Image.data && attributes.Image.data.attributes && attributes.Image.data.attributes.url,
            stats,
            text,
            leaders,
            team,
        }
    }

    return results;
});

export default aboutSelector;
